function RecoverPassword() {
  return (
    <div className="iframeZoho">
      <iframe
        className="iframeForm"
        frameBorder="0"
        scrolling="auto"
        src="https://creatorapp.zohopublic.com/vt.cel/tecnosuper/form-embed/Recuperar_contrasena/Vj2t3QKXTCvP1KGyAdynybAtXs1HObYWm4FD4f6FpxGZFxTF0vXpZR99b5h7fvUfH4nr1NydOzuEyA3rmRxCmujVvjJs2bZCYYsC"
      ></iframe>
    </div>
  );
}

export default RecoverPassword;
